
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/campaign/fctokyo_202110",
      function () {
        return require("private-next-pages/campaign/fctokyo_202110/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/campaign/fctokyo_202110"])
      });
    }
  